<template>
        <div
            v-if='value.op == "and" || value.op == "or"'
            class='tw-flex tw-items-start'
            :class="[!parent ? 'tw-flex-col' : '']"
        >
            <div v-if='parent' style='width: 60px; height: 40px; position: relative;'>
                <div style='position: absolute; background-color: #888; width: 100%; height: 2px; top: 18px;'>
                </div>
                <span v-if='removable' 
                    class='mdi mdi-close-circle-outline tw-cursor-pointer' 
                    style='color: cornflowerblue; background-color: #f8f8f8; position: absolute; top: 7px; left: 20px;' @click.native='$emit("remove")'></span>
            </div>
            <div class="tw-flex tw-flex-col">
            <div class='tw-flex tw-items-center'>
                <TSimplePicker
                    buttonClass="tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
                    class="tw-w-auto"
                    v-model="value.op"
                    :items="[
                        {
                            value: 'and',
                            label: 'All'
                        },
                        {
                            value: 'or',
                            label: 'Any'
                        },
                    ]"
                    :format="val => val.label"
                ></TSimplePicker>
                <span class='tw-ml-2'>of the following:</span>
            </div>
            <div class='tw-flex tw-items-stretch'>
                <div style='background-color: #888; margin-bottom: 24px; border-bottom-left-radius: 2px; margin-left: 15px; width: 2px;'></div>
                <div class='tw-flex-1'>
                    <div v-for="(rule, i) in value.rules" style='margin-top: 10px; margin-bottom: 10px;'>
                        <RuleWrapper
                            :placeholder="placeholder"
                            :store="store"
                            @remove='value.rules.splice(i,1)' :parent='value' :removable="value.rules.length > 1" :value="rule" @input="updateRule($event, i)"></RuleWrapper>
                    </div>
                    <div class='tw-flex tw-items-center' style='height: 30px; margin-bottom: 10px;'>
                        <div style='background-color: #888; width: 20px; height: 2px;'></div>
                        <span class='mdi mdi-plus-circle-outline'></span>
                        <div style='margin-left: 25px;'>
                            add a new 
                            <a class='tw-cursor-pointer tw-text-blue-500 hover:tw-text-blue-900' @click.prevent='addCondition'>condition</a> or 
                            <a class='tw-text-blue-500 hover:tw-text-blue-900 tw-cursor-pointer' @click.prevent='addGroup'>group</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div
            v-else
            class='tw-flex tw-w-full tw-items-center'>
            <div v-if='parent' style=' width: 60px; height: 40px; position: relative;'>
                <div style='position: absolute; background-color: #888; width: 100%; height: 2px; top: 18px;'>
                </div>
                <span v-if='removable' class='mdi mdi-close-circle-outline tw-cursor-pointer' style='color: cornflowerblue; background-color: #f8f8f8; position: absolute; top: 7px; left: 20px;' 
                    @click.native='$emit("remove")'></span>
                </div><SimpleRule
                :placeholder="placeholder"
                :store="store"
                class='tw-flex-1'
                :value="value" @input="em"
            />
        </div>
</template>
<script>
import SimpleRule   from './SimpleRule.vue';
import { TSimplePicker } from '@roonlabs/vue-tailwind';

export default {
    name: 'RuleWrapper', 
    components: { SimpleRule, TSimplePicker },
    props: {
        value:       Object,
        removable:   Boolean,
        parent:      Object,
        store:       Object,
        placeholder: String
    },
    methods: {
        em(e) {
            this.$emit('input',e)
        },
        addCondition() {
            this.$emit("input", {
                op: this.value.op,
                rules: [
                    ...this.value.rules,
                    {
                        op: "==",
                        field: null,
                        value: "",
                    },
                ]
            })
        },
        addGroup() {
            this.$emit("input", {
                op: this.value.op,
                rules: [
                    ...this.value.rules,
                    {
                        op: "and",
                        rules: [
                            {
                                op: "==",
                                field: null,
                                value: "",
                            }
                        ]
                    },
                ]
            })
        },

        updateRule(rule, index) {
            this.$emit("input", {
                op: this.value.op,
                rules: this.value.rules.map((r, i) => (i === index ? rule : r)),
                });
        },

        removeRule(index) {
            this.$emit("input", {
                op: this.value.op,
                rules: this.value.rules.filter((r, i) => i !== index),
                });
        },
    }
}
</script>
